const XSS_PATTERN = /(<script|onerror=|onload=|javascript:|data:text\/html|<iframe|<object|<embed|<svg|<link|<meta)/gi;

export function sanitizeHtml(input) {
  if (!input || typeof input !== 'string') return '';
  let cleaned = input.replace(/\0/g, '');
  cleaned = cleaned.replace(/(href|src)=("|')javascript:[^"']*("|')/gi, '$1="#"');
  cleaned = cleaned.replace(/ on[a-zA-Z]+=("[^"]*"|'[^']*')/g, '');
  cleaned = cleaned.replace(XSS_PATTERN, (m) => `<!-- blocked:${m.slice(0,10)} -->`);
  return cleaned;
}

export function escapeText(text) {
  if (text == null) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export const tokenStore = {
  get() {
    try { return localStorage.getItem('token'); } catch { return null; }
  },
  set(token) {
    try {
      if (token) localStorage.setItem('token', token); else localStorage.removeItem('token');
    } catch {/* ignore */}
  },
  clear() { this.set(null); }
};

export function sanitizedHtml(input) {
  const sanitized = sanitizeHtml(input);
  if (process.env.NODE_ENV !== 'production' && sanitized !== input) {
    // eslint-disable-next-line no-console
    console.warn('[security] Blog content sanitized – potential XSS markup removed.');
  }
  return { __html: sanitized };
}

export async function safeFetch(url, options = {}, { timeoutMs = 12000 } = {}) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  const headers = new Headers(options.headers || {});
  if (!headers.has('Accept')) headers.set('Accept', 'application/json');
  const finalOpts = { ...options, headers, signal: controller.signal };
  try {
    const res = await fetch(url, finalOpts);
    let data = null;
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) {
      try { data = await res.json(); } catch { data = null; }
    } else {
      data = await res.text();
    }
    return { ok: res.ok, status: res.status, data, headers: res.headers };
  } finally {
    clearTimeout(timer);
  }
}

